import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sort-arrow-down-icon',
  templateUrl: './sort-arrow-down-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SortArrowDownIconComponent {}
